import { useRef, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import img1 from 'assets/images/Parallax1.jpg';
import img2 from 'assets/images/Parallax2.jpg';
import img3 from 'assets/images/Parallax3.jpg';

// import slideimg from 'assets/images/slideimg.png';

// import slideimg from 'assets/images/slideimg.png';

import styles from './ParallaxSection.module.scss';

import Config from 'config/config.json';
import {getLocaleTag} from 'services/i18n.js';

const { contentfulTranslationsPath, contentfulAccessToken } = Config;

const ParallaxSection = ({t, handleSkewGalleryButton}) => {
    const wrapRef = useRef(null);
    const img1Ref = useRef(null);
    const img2Ref = useRef(null);
    const img3Ref = useRef(null);
    const ctaRef = useRef(null);

    // const [img1, setImg1] = useState('');
    // const [img2, setImg2] = useState('');
    // const [img3, setImg3] = useState('');
    const [cta, setCta] = useState('');
    const [ready, setReady] = useState(false);

    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
        fetch(contentfulTranslationsPath, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${contentfulAccessToken}`
            },
            body: JSON.stringify({ query: `
                {
                    drop2ScrollSectionCollection(limit:1, where: {contentfulMetadata: {
                        tags: {
                            id_contains_all: "${getLocaleTag()}"
                        }
                    }}){
                        items {
                            cta {
                                url
                            }
                        }
                    }
                }
            `})
        }).then(res => res.json())
        .then(({data}) => {
            if(
                !data || 
                !data.drop2ScrollSectionCollection || 
                !data.drop2ScrollSectionCollection.items || 
                !data.drop2ScrollSectionCollection.items[0]
            ){
                return;
            }
            const images = data.drop2ScrollSectionCollection.items[0];
            // setImg1(images.image1.url);
            // setImg2(images.image2.url);
            // setImg3(images.image3.url);
            setCta(images.cta.url);
            setReady(true);
        });
    }, []);

    useEffect(() => {
        if(ready){
            ScrollTrigger.update();
            setTimeout(() => {
                gsap.timeline({
                    scrollTrigger: {
                        trigger: wrapRef.current,
                        start: 'top bottom',
                        end: '+=200%',
                        scrub: 0.2
                    }
                }).fromTo(img1Ref.current, {y: '70vh'}, {y: '-10vh', duration: 1})
                .fromTo(img2Ref.current, {y: '35vh'}, {y: '-5vh', duration: 1}, '-=1')
                .fromTo(img3Ref.current, {y: '52.5vh'}, {y: '-7.5vh', duration: 1}, '-=1')
                .fromTo(ctaRef.current, {y: '17.5vh'}, {y: '-2.5vh', duration: 1}, '-=1');
                ScrollTrigger.update();
            }, 500);
        }
    }, [ready]);

    return (
        <div ref={wrapRef} className={styles.grid}>

            <img ref={img1Ref} className={styles.image1} alt='' src={img1} />
            <img ref={img2Ref} className={styles.image2} alt='' src={img2} />
            <div className={styles.text}>
                <h1>{t('drop2_module3_hed')}</h1>
                <p>{t('drop2_module3_sub')}</p>
                <img ref={ctaRef} className={styles.slideimg} 
                    onClick={handleSkewGalleryButton} src={cta} alt='' />
            </div>
            <img ref={img3Ref} className={styles.image3} src={img3} alt='' />

        </div>
    );
}

export default withTranslation()(ParallaxSection);